<template>
  <div id="home">
    <!-- loading 状态 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <div class="loading-text">加载中...</div>
    </div>
    <!-- 内容区域 -->
    <div v-else>
      <!-- about、轮播 -->
      <div id="banner">
        <div id="banner-container">
          <div id="about">
            <div class="title_flag"></div>
            <div class="about_title">关于我们</div>
            <div class="about_content">
              <p>
                广州市台资企业协会成立于1994年，致力于为在穗台商台胞为广州经济社会发展、穗台融合发展做出最大的贡献，持续推动穗台应通尽通、融合发展，穗台经贸合作水平稳步提升。发挥“领头羊”作用，当好两岸关系和平发展、穗台融合发展的示范者、领跑者、推动者、实践者，团结和带领更多爱国台胞，共担民族大义、共赴民族复兴，做堂堂正正的中国人!
              </p>
            </div>
          </div>
          <div id="swipe">
            <SwiperComponent></SwiperComponent>
          </div>
        </div>
      </div>
      <!-- 协会资讯、办事指南、政策法规 -->
      <div id="content">
        <div class="content_box">
          <div class="xhzs">
            <div class="xhzs_flag"></div>
            <div class="title">协会资讯</div>
            <div class="xhzs_icon"></div>

            <div v-for="article in articles.news" :key="article.url" class="item"  @click="itemClick(article,'协会资讯')">
              <img :src="changeImgUrl(article.img)" :alt="article.title" class="itme_img" />
              <div class="item_right">
               <div class="item_text1">{{ article.title }}</div>
               <div class="item_time1">{{ article.createtime }}</div>
              </div>
            </div>
          </div>
          <div class="bszn_zsfg">
            <div class="tab">
              <div :class="tab_bszn" @click="navClick(1)">
                <label for="">办事指南</label>
              </div>
              <div :class="tab_zsfg" @click="navClick(2)">
                <label for="">政策法规</label>
              </div>
            </div>
            <div class="tab_content">
              <template v-if="tab_bszn.includes(tab_active)">
                <div v-for="article in articles.guide" :key="article.url" class="tab_content_item" @click="itemClick(article,'办事指南')">
                  <div style="float: left; width: 120px; height: 90px;">
                    <img :src="changeImgUrl(article.img)" :alt="article.title" />
                  </div>
                  <div  style="float: left;width: 380px;">
                    <p style="font-size: 18px;">{{ article.title }}</p>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-for="article in articles.policy" :key="article.url" class="tab_content_item"  @click="itemClick(article,'政策法规')">
                  <div style="float: left; width: 120px; height: 90px;">
                    <img :src="changeImgUrl(article.img)" :alt="article.title" />
                  </div>
                  <div  style="float: left;width: 380px;">
                    <p style="font-size: 18px;">{{ article.title }}</p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- 加入会员 -->
      <JoinMemberComponent></JoinMemberComponent>
      <!-- 底部链接 -->
      <FooterComponent></FooterComponent>
      <!-- 版权 -->
      <CopyrightLayout></CopyrightLayout>
    </div>
  </div>
</template>
<script>
import { articleApi } from '@/api/article';
import SwiperComponent from "@/components/SwiperComponent.vue";
import JoinMemberComponent from "@/components/JoinMemberComponent.vue";
import FooterComponent from "./FooterComponent.vue";
import CopyrightLayout from "@/layout/CopyrightLayout.vue";
import base64 from 'base-64';
export default {
  name: "HomePage",
  components: { 
    SwiperComponent,
    JoinMemberComponent,
    FooterComponent,
    CopyrightLayout 
  },
  data() {
    return {
      tab_bszn: "tab_bszn",
      tab_zsfg: "tab_zsfg",
      tab_active: "tab_active",
      articles: {
        guide: [], // 办事指南
        policy: [], // 政策法规
        news: []   // 协会资讯
      },
      loading: true // 默认为 true，表示初始加载状态
    };
  },
  methods: {
    changeImgUrl(url){
      return url.replace("https://static.duud.cn/", "https://wq-1258021341.cos.ap-guangzhou.myqcloud.com/");
    },
    navClick(num) {
      if(num == 1) {
        this.tab_zsfg = "tab_zsfg " + this.tab_active;
        this.tab_bszn = "tab_bszn";
      } else {
        this.tab_bszn = "tab_bszn " + this.tab_active;
        this.tab_zsfg = "tab_zsfg";
      }
    },
    itemClick(item,name){
      console.info('name:',name)
      let tab_idx = 1;
      if(name=='办事指南'){
        tab_idx = 3;
      }else if(name=='政策法规'){
        tab_idx = 4;
      }else if(name=='协会资讯'){
        tab_idx = 2;
      }
      
      const page = "https://duud.cn/app/" + item.url;
      const base64Url = base64.encode(page);
      this.$router.push({ name: 'articleDetail', query: { url: base64Url, category:name,idx:tab_idx } });
    },
    async fetchArticles() {
      this.loading = true;
      try {
        const res = await articleApi.getCategoryLatestArticles();
        if (res.data) {
          this.articles.news = res.data['28'] || [];
          this.articles.guide = res.data['35'] || [];
          this.articles.policy = res.data['63'] || [];
        }
      } catch (error) {
        console.error('获取文章失败:', error);
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.navClick(1);
    this.fetchArticles();
  },
};
</script>

<style>
@import "../style/common.css";
@import "../style/home.css";

/* Loading 样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  margin-top: 20px;
  font-size: 16px;
  color: #333;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>